import * as PIXI from "pixi.js";
import Game from "../../../../../src/Game";
import Layers from "../../../../../src/layers/Layers";
import { eventBus, EnumEventBus } from "../managers/EventBus";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { CALC_LINE_COORD, CALC_LINE_INITIAL_TEXT_OBJ } from "../types/Config";


export default class CalculationLine extends PIXI.Container {
  private Game = Game.getInstance();
  private Layers = Layers.getInstance();

  constructor() {
    super();
    this.addText();
    this.addCoord();
    this.addToLayer();

    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.visible = false);
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.visible = true);
    eventBus.on(EnumEventBus.setCalcLine, (degree: string) => this.updateDegrees([Number(degree), Number(degree) / 2]));
  }

  private addToLayer = () => this.Layers.Info.addChild(this);
  private addText = () => CALC_LINE_INITIAL_TEXT_OBJ.forEach(text => this.generateText(text));
  
  private generateText(text: { text: string, x: number, y: number, color: number, fontSize?: number, fontWeight?: PIXI.TextStyleFontWeight }) {
    const T = new PIXI.Text()
    T.text = text.text
    T.x = text.x;
    T.y = text.y;
    T.style.fill = text.color;
    T.style.fontSize = text.fontSize ? text.fontSize : 50
    T.style.fontWeight = text.fontWeight ? text.fontWeight : "500";
    this.addChild(T);
  }

  updateDegrees(degrees: (number | string)[]) {
    (this.children[2] as PIXI.Text).text = `${degrees[1]}°`;
    (this.children[4] as PIXI.Text).text = `${degrees[0]}°`;
  }
  addCoord() {
    const dim = this.Game.getDim();
    const Coord = (dim.WIDTH > dim.HEIGHT)
      ? CALC_LINE_COORD
      : {
          x: dim.WIDTH / 2 - 200,
          y: dim.HEIGHT / 2 + 250
        };
    
    Object.assign(this, Coord);
  }
}